"use client";

import { startTransition } from "react";

/**
 * Time-based reassurance, not progress. Kundali generation normally takes
 * 20–35 seconds, and none of these messages claims that an engine stage has
 * completed before the response arrives.
 */
export const LOADING_STATUS_MESSAGES = [
  {
    en: "Preparing your chart. This usually takes 20–35 seconds.",
    hi: "Aapki kundali taiyar ho rahi hai. Ismein aam taur par 20–35 seconds lagte hain.",
  },
  {
    en: "Calculating your planetary chart. Please keep this page open.",
    hi: "Aapke graha calculate ho rahe hain. Kripya yeh page khula rakhein.",
  },
  {
    en: "Still working through the details. Some charts take a little longer.",
    hi: "Details par kaam abhi jaari hai. Kuch kundali mein thoda aur samay lagta hai.",
  },
] as const;

export const LOADING_STATUS_DELAYS_MS = [12_000, 28_000] as const;

export function loadingStatusTimers(setStatus: (status: number) => void) {
  return LOADING_STATUS_DELAYS_MS.map((delay, index) =>
    setTimeout(() => startTransition(() => setStatus(index + 1)), delay)
  );
}
